package io.horion.cv.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun SocialLoginButton(
    text: String,
    iconSrc: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    isMobile: Boolean = false
) {
    Row(
        modifier = modifier
            .width(if (isMobile) 260.px else 240.px)
            .height(40.px)
            .border(1.px, LineStyle.Solid, Colors.lineBorder)
            .borderRadius(6.px)
            .padding(leftRight = 20.px)
            .gap(10.px)
            .onClick { onClick() }
            .cursor(Cursor.Pointer),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Image(
            src = iconSrc,
            description = text,
            modifier = Modifier.size(20.px)
        )
        SpanText(
            text = text,
            modifier = Modifier
                .fontSize(if (isMobile) 13.px else 15.px)
                .fontFamily(INTER)
                .fontWeight(FontWeight.Light)
                .color(Colors.Primary)
        )
    }
}